import { ColorSwatch, displayOrNone, Row } from 'components/production/components/AisleContent/SummaryComponents';

/**
 * Summary view for the banner editor.
 *
 * @param {Object} data - Non-configurable banner data.
 * @param {Object} formData - Configurable banner data.
 */
export default function BannerEditorSummary({ data, formData }) {
    return (
        <div className="grid grid-cols-[max-content_1fr] gap-y-1 gap-x-8 items-baseline">
            <Row label="id">
                <p className="text-sm">{displayOrNone(data.id)}</p>
            </Row>
            <Row label="Active">
                <p className="text-sm">{formData.active ? 'Yes' : 'No'}</p>
            </Row>
            <Row label="Images (large, small)" labelClass="mb-0.5">
                <ImagePair largeImage={formData.largeImage} smallImage={formData.smallImage} />
            </Row>
            <Row label="Name">
                <p className="text-sm">{displayOrNone(formData.bannerName)}</p>
            </Row>
            <Row label="Copy">
                <p className="text-sm">{displayOrNone(formData.copy)}</p>
            </Row>
            <Row label="Link URL">
                <p className="text-sm">{displayOrNone(formData.linkURL)}</p>
            </Row>
            <Row label="Link Text">
                <p className="text-sm">{displayOrNone(formData.linkTitle)}</p>
            </Row>
            <Row label="Background Color" labelClass="transform -translate-y-1">
                <ColorSwatch color={formData.backgroundColor} />
            </Row>
        </div>
    );
}

/**
 * Displays a pair of images.
 *
 * @param {string} largeImage - The URL of the large image.
 * @param {string} smallImage - The URL of the small image.
 */
function ImagePair({ largeImage, smallImage }) {
    const BASE_URL = 'https://img-cdn.misfitsmarket.com/';
    return (
        <div className="flex gap-2">
            {largeImage ? (
                <img alt="" className="max-w-60 h-15" src={`${BASE_URL}${largeImage}`} />
            ) : (
                <span className="italic text-muted-foreground">None</span>
            )}
            {smallImage ? (
                <img alt="" className="max-w-60 h-15" src={`${BASE_URL}${smallImage}`} />
            ) : (
                <span className="italic text-muted-foreground">None</span>
            )}
        </div>
    );
}
